<template>
    <div style="display:grid" :class="darkmode ? 'bg-dark' : ''">
        <NavBar id="nav" style="z-index: 1024"/>
        <div style="display:grid">
            <transition name="main">
                <router-view :class="darkmode ? 'bg-dark text-light border-secondary' : ''" style="grid-column:1;grid-row:2" />
            </transition>
        </div>
        <!--<b-modal 
            v-if="$route.query.coronawarn"
            title="Corona-Hinweis"
            :visible="$route.query.coronawarn" 
            okTitle="Verstanden" ok-only
            @hidden="$router.go(-1)"
            :header-bg-variant="darkmode ? 'dark' : ''"
            :header-text-variant="darkmode ? 'light' : ''"
            :body-bg-variant="darkmode ? 'dark' : ''" 
            :body-text-variant="darkmode ? 'light' : ''"
            :footer-bg-variant="darkmode ? 'dark' : ''"
            :footer-text-variant="darkmode ? 'light' : ''"
        >
            <strong>Achtet bitte auch beim Mitfahren auf den Schutz vor Covid&#8209;19:</strong>
            <div class="d-flex flex-row">
                <ul class="ml-n2 align-self-center my-2">
                    <li>Vermeidet Körperkontakt.</li>
                    <li>Tragt auch im Auto Schutzmasken.</li>
                    <li>Wascht euch vor und nach der Fahrt die Hände.</li>
                    <li>Versucht euch nicht direkt nebeneinander zu setzen.</li>
                    <li>Lasst die Fenster während der Fahrt wenn möglich geöffnet.</li>
                </ul>
                <div class="ml-2 my-2 d-flex flex-column justify-content-around">
                    <img src="./assets/interface/viruslogo.svg" width="50em"/>
                    <img src="./assets/interface/mask.svg" class="my-1" width="50em"/>
                    <img src="./assets/interface/nohands.svg" width="50em"/>
                </div>
            </div>
            <p>Wir wünschen allen Schülern & Lehrern eine sichere und unfallfreie Fahrt!</p>
        </b-modal>-->
    </div>
</template>

<script>
import NavBar from "./components/NavBar.vue"
import { mapGetters } from 'vuex'

export default {
    name: "App",
    components: {
        NavBar
    },
    computed: mapGetters(['darkmode']),
    mounted(){
        this.darkmode ? document.body.classList.add('bg-dark') : document.body.classList.remove('bg-dark')
    }
}
</script>

<style>
    .main-enter-active, .main-leave-active {
        -webkit-transition:  transform .5s ease-in-out, opacity .5s ease-in-out;
        -moz-transition:  transform .5s ease-in-out, opacity .5s ease-in-out;
        -ms-transition:  transform .5s ease-in-out, opacity .5s ease-in-out;
        -o-transition:  transform .5s ease-in-out, opacity .5s ease-in-out;
        transition:  transform .5s ease-in-out, opacity .5s ease-in-out;
    }
    .main-enter{
        opacity: 0;
        transform: translateY(-100%)
    }
    .main-leave-to{
        opacity: 0;
        transform: scale(0.6)
    }
</style>